
import { AfterContentInit, Directive, OnDestroy } from "@angular/core";
import { isEmpty } from "lodash";
import { Subscription } from "rxjs";
import { distinctUntilChanged, tap } from "rxjs/operators";

import { ToggleFieldGroupComponent } from "../field-toggle-group.component";
import { FieldToggleManager } from "../toggle-manager.service";

@Directive({
    selector: "common-field-toggle-group[hidden-fields-strategy]",
    providers: [FieldToggleManager],
})
export class HiddenFieldsStrategyDirective implements OnDestroy, AfterContentInit {
    private state$: Subscription;
    private toggleState$: Subscription[];

    constructor(
        private hostRef: ToggleFieldGroupComponent,
        private toggleManager: FieldToggleManager,
    ) { }

    public ngAfterContentInit(): void {
        this.state$ = this.toggleManager.state$.pipe(
            tap((state) => {
                if (isEmpty(this.toggleManager.allToggleFieldProps)) {
                    this.setToggleFieldActiveState(false);
                    this.hostRef.toggleControls.forEach((toggleControl) => toggleControl.disableToggle = false);
                }
            }),
            distinctUntilChanged(this.toggleManager.distinctUntilChangedFactory(this.toggleManager.allToggleFieldProps)))
            .subscribe((state) => {
                this.activateToggleFieldsIfEmpty();
                this.disableToggleControlsIfNeeded();
                this.toggleManager.toggleNextState();
                this.synchronizeState(state);
            });

        this.toggleState$ = this.hostRef.toggleControls.map((toggleControl) => {
            return toggleControl.toggleState$.subscribe((toggleState) => {
                this.setToggleFieldActiveState(toggleState);
                if (!toggleState) { toggleControl.disableToggle = false; }
            });
        });
    }

    public ngOnDestroy(): void {
        this.state$.unsubscribe();
        this.toggleState$.forEach((state) => state.unsubscribe());
    }

    public synchronizeState(state): void {
        this.hostRef.toggleFields.forEach((field) => field.isDisabled = !this.toggleManager.toggleFieldsAreEmpty);
        this.hostRef.toggleControls.map((toggleControl) => {
            if (toggleControl.toggleState && toggleControl.disableToggle) { toggleControl.disableToggle = false; }
            if (toggleControl.toggleState) { this.setToggleFieldActiveState(true); }
        });
    }

    public setToggleFieldActiveState(state): void {
        this.hostRef.toggleFields.forEach((toggleField) => toggleField.isActivated = state);
        this.disableToggleControlsIfNeeded();
    }

    public activateToggleFieldsIfEmpty(): void {
        if (!this.toggleManager.toggleFieldsAreEmpty) { this.setToggleFieldActiveState(true); }
    }

    public disableToggleControlsIfNeeded(): void {
        this.hostRef.toggleControls.forEach((toggleControl) => {
            toggleControl.disableToggle = !this.toggleManager.toggleFieldsAreEmpty;
        });
    }
}
